import React from "react";
import { Container, Paper, Typography } from "@mui/material";
import { PasswordChangeForm } from "../components/PasswordChangeForm";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";

export const PasswordChangePage: React.FC = () => {
  const { user } = useAuth();

  // If no user, the ProtectedRoute will handle redirection
  if (!user) return null;

  // if (!allowedRoles.includes(user.role)) {
  //   return <Navigate to="/" replace />;
  // }

  return (
    <ProtectedRoute>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
          <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 2 }}>
            Logged in as: {user.first_name} {user.last_name} ({user.role})
          </Typography>
          <PasswordChangeForm />
        </Paper>
      </Container>
    </ProtectedRoute>
  );
};
